const restaurantConfig = {
  businessName: "Spice Garden",
  businessCategory: "Restaurant & Fine Dining",
  productsLabel: "Our Menu",
  tagline: "Authentic Flavours, Unforgettable Moments",
  description: "Spice Garden is a premium dining destination celebrating the rich culinary heritage of India with modern presentation and exceptional hospitality.",
  mission: "To serve authentic, flavourful food that brings people together.",
  vision: "To be the most celebrated dining destination in the city.",
  logo: null,
  favicon: null,
  theme: {
    primaryColor: "#e63946",
    secondaryColor: "#c1121f",
    accentColor: "#f4a261",
    backgroundColor: "#fffaf7",
    textColor: "#1d1d1d",
    darkBackground: "#1a0a00",
    darkText: "#fdf0e0",
    borderRadius: "12px",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  },
  darkModeEnabled: true,
  defaultDarkMode: false,
  seo: {
    title: "Spice Garden | Authentic Indian Fine Dining",
    description: "Experience authentic Indian cuisine at Spice Garden. Book your table for an unforgettable dining experience.",
    keywords: "restaurant, Indian food, fine dining, biryani, curry, spice garden",
    ogImage: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200&q=80",
    twitterCard: "summary_large_image",
  },
  contact: {
    phone: "+91 98765 22222",
    whatsapp: "919876522222",
    email: "reservations@spicegarden.com",
    website: "www.spicegarden.com",
    address: "7, Food Street, Connaught Place, New Delhi - 110001",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.11609823277!2d72.74109995709657!3d19.08250589563531!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c6306644edc1%3A0x5da4ed8f8d648c69!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1718000000000",
  },
  businessHours: [
    { day: "Monday – Thursday", hours: "12:00 PM – 11:00 PM" },
    { day: "Friday – Saturday", hours: "12:00 PM – 12:00 AM" },
    { day: "Sunday", hours: "11:00 AM – 10:00 PM" },
  ],
  social: { facebook: "https://facebook.com", instagram: "https://instagram.com", linkedin: "", youtube: "https://youtube.com", twitter: "" },
  hero: {
    heading: "A Feast for the Senses",
    subheading: "Authentic Indian flavours crafted with passion, served with love.",
    ctaPrimary: { label: "Reserve a Table", link: "/restaurant/contact" },
    ctaSecondary: { label: "View Menu", link: "/restaurant/services" },
    images: [
      "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1400&q=80",
      "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1400&q=80",
      "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=1400&q=80",
    ],
  },
  about: {
    heading: "Our Culinary Story",
    subheading: "Serving Authentic Flavours Since 2010",
    body: "Spice Garden was born from a deep love for Indian culinary traditions. Our chefs bring decades of expertise, using age-old recipes and the finest ingredients to create dishes that transport you to the heart of India.",
    highlights: ["Award-Winning Chefs", "Farm-to-Table Ingredients", "Private Dining Available", "Catering Services"],
    image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&q=80",
  },
  services: [
    { id: 1, icon: "FaUtensils", title: "Starters & Appetizers", description: "Crispy samosas, tandoori platters, and signature chaat to begin your journey.", image: "" },
    { id: 2, icon: "FaLeaf", title: "Vegetarian Delights", description: "A rich selection of paneer, dal, and vegetable curries bursting with flavour.", image: "" },
    { id: 3, icon: "FaShieldAlt", title: "Signature Biryanis", description: "Slow-cooked dum biryanis in Hyderabadi, Lucknowi, and Kolkata styles.", image: "" },
    { id: 4, icon: "FaCalendarAlt", title: "Private Events", description: "Exclusive dining experiences for weddings, corporate events, and celebrations.", image: "" },
    { id: 5, icon: "FaHome", title: "Catering Services", description: "Full-service catering for events of all sizes, delivered fresh to your venue.", image: "" },
    { id: 6, icon: "FaMobileAlt", title: "Online Ordering", description: "Order your favourite dishes online for delivery or takeaway.", image: "" },
  ],
  stats: [
    { value: 200, label: "Menu Items", suffix: "+" },
    { value: 14, label: "Years of Excellence", suffix: "+" },
    { value: 50000, label: "Happy Diners", suffix: "+" },
    { value: 4.8, label: "Average Rating", suffix: "★" },
  ],
  whyUs: {
    heading: "Why Dine With Us?",
    subheading: "An experience beyond just food",
    points: [
      { icon: "FaUtensils", title: "Authentic Recipes", description: "Traditional recipes passed down through generations of master chefs." },
      { icon: "FaLeaf", title: "Fresh Ingredients", description: "Locally sourced, seasonal ingredients for maximum flavour and nutrition." },
      { icon: "FaHome", title: "Elegant Ambience", description: "A beautifully designed space perfect for every occasion." },
      { icon: "FaShieldAlt", title: "Hygiene Certified", description: "FSSAI certified kitchen with the highest hygiene standards." },
    ],
  },
  gallery: [
    { id: 1, src: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&q=80", alt: "Restaurant Interior", category: "Ambience" },
    { id: 2, src: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&q=80", alt: "Signature Dish", category: "Food" },
    { id: 3, src: "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=800&q=80", alt: "Bar Area", category: "Ambience" },
    { id: 4, src: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=800&q=80", alt: "Biryani", category: "Food" },
    { id: 5, src: "https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=800&q=80", alt: "Desserts", category: "Food" },
    { id: 6, src: "https://images.unsplash.com/photo-1424847651672-bf20a4b0982b?w=800&q=80", alt: "Private Dining", category: "Ambience" },
  ],
  pricing: [
    { id: 1, name: "Lunch Thali", price: "₹399", period: "per person", features: ["2 Curries", "Dal & Rice", "Roti & Naan", "Dessert", "Papad & Pickle"], highlighted: false },
    { id: 2, name: "Dinner for Two", price: "₹1,299", period: "for 2 people", features: ["Starter Platter", "2 Main Courses", "Biryani", "Dessert", "Soft Drinks"], highlighted: true },
    { id: 3, name: "Banquet Package", price: "₹799", period: "per person", features: ["Welcome Drinks", "Full Buffet", "Live Counter", "Dessert Station", "Dedicated Staff"], highlighted: false },
  ],
  testimonials: [
    { id: 1, name: "Vikram Malhotra", role: "Food Critic", review: "The best biryani I've had outside of Hyderabad. The flavours are authentic and the service is impeccable.", rating: 5, avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=80" },
    { id: 2, name: "Kavya Reddy", role: "Regular Diner", review: "We celebrated our anniversary here and it was magical. The private dining setup was absolutely stunning.", rating: 5, avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=80" },
    { id: 3, name: "Suresh Iyer", role: "Corporate Client", review: "Spice Garden catered our company event for 200 people. Everything was perfect — food, service, and presentation.", rating: 5, avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&q=80" },
  ],
  team: [
    { id: 1, name: "Chef Rajan Pillai", role: "Executive Chef", bio: "30 years of culinary mastery across India and abroad.", image: "https://images.unsplash.com/photo-1583394293214-0d0e7b4e8e8e?w=400&q=80", social: { linkedin: "#", twitter: "#" } },
    { id: 2, name: "Chef Anita Sharma", role: "Pastry & Desserts", bio: "Trained in Paris, specialising in Indian fusion desserts.", image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80", social: { linkedin: "#", twitter: "#" } },
    { id: 3, name: "Rahul Verma", role: "Restaurant Manager", bio: "Ensuring every guest leaves with a smile.", image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80", social: { linkedin: "#", twitter: "#" } },
  ],
  faq: [
    { id: 1, question: "Do I need a reservation?", answer: "Walk-ins are welcome, but we recommend reservations for weekends and special occasions." },
    { id: 2, question: "Do you offer vegetarian and vegan options?", answer: "Yes, over 60% of our menu is vegetarian. We also have dedicated vegan dishes." },
    { id: 3, question: "Can you accommodate large groups?", answer: "Yes, we have private dining rooms for groups of 10 to 150 guests." },
    { id: 4, question: "Do you provide catering services?", answer: "Yes, we cater for weddings, corporate events, and private parties across the city." },
  ],
  cta: { heading: "Reserve Your Table Tonight", subheading: "An unforgettable dining experience awaits you.", buttonLabel: "Book a Table", buttonLink: "/restaurant/contact" },
  footer: {
    tagline: "Authentic Flavours, Unforgettable Moments.",
    copyright: `© ${new Date().getFullYear()} Spice Garden. All Rights Reserved.`,
    links: [
      { label: "Home", path: "/restaurant" },
      { label: "Menu", path: "/restaurant/services" },
      { label: "Gallery", path: "/restaurant/gallery" },
      { label: "Contact", path: "/restaurant/contact" },
    ],
  },
  products: [
    { id: 1, name: "Chicken Dum Biryani", category: "Biryani", price: 349, originalPrice: null, image: "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?w=600&q=80", description: "Slow-cooked Hyderabadi dum biryani with tender chicken, saffron, and caramelised onions.", badge: "Chef's Special", inStock: true },
    { id: 2, name: "Paneer Butter Masala", category: "Vegetarian", price: 280, originalPrice: null, image: "https://images.unsplash.com/photo-1631452180519-c014fe946bc7?w=600&q=80", description: "Creamy tomato-based gravy with soft paneer cubes, best paired with naan or rice.", badge: "Best Seller", inStock: true },
    { id: 3, name: "Tandoori Platter (4 pcs)", category: "Starters", price: 399, originalPrice: 499, image: "https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?w=600&q=80", description: "Assorted tandoori chicken, seekh kebab, and paneer tikka with mint chutney.", badge: "Popular", inStock: true },
    { id: 4, name: "Gulab Jamun (6 pcs)", category: "Desserts", price: 149, originalPrice: null, image: "https://images.unsplash.com/photo-1601050690597-df0568f70950?w=600&q=80", description: "Soft, melt-in-mouth gulab jamuns soaked in rose-flavoured sugar syrup.", badge: null, inStock: true },
  ],
  sections: { hero: true, about: true, services: true, whyUs: true, stats: true, gallery: true, pricing: true, testimonials: true, team: true, faq: true, cta: true, contact: true, products: true, enquireMode: false },
};

export default restaurantConfig;
